import { useQuery } from '@tanstack/react-query';

import { FALLBACK_SIDEBAR_RESPONSE } from './constants';
import { getServerUrl } from '../../../utils/getServerUrl';
import { useQuerySession } from '../../../hooks/useQuerySession';

import type { SidebarV3 } from './types';

export const useQuerySidebar = () => {
  const { data: sessionData } = useQuerySession();
  const currentAccountId = sessionData?.currentAccountId?.toString() || '';
  const isStaff = sessionData?.isStaff?.toString() || '';
  const userId = sessionData?.customUserId?.toString() || '';

  const result = useQuery<SidebarV3.APIResponse>({
    queryKey: ['sidebar', currentAccountId, isStaff, userId],
    queryFn: async () => {
      const serverUrl = getServerUrl();
      const sidebarUrl = `${serverUrl}/api/v3/navigation-data/sidebar`;

      const response = await fetch(sidebarUrl, {
        credentials:
          process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
        headers: {
          'x-is-staff': isStaff,
          'x-current-account-id': currentAccountId,
          'x-customuser-id': userId,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const json = await response.json();
      return json.data;
    },
    placeholderData: FALLBACK_SIDEBAR_RESPONSE,
  });

  const data =
    result.isLoading || result.isError
      ? FALLBACK_SIDEBAR_RESPONSE
      : result.data;

  return {
    ...result,
    data,
  };
};
